import React from 'react';
import { Link } from 'react-router-dom';
import { useNavigation } from '../../contexts/NavigationContext';
import './Footer.css';

// Import SVGs
import footerLogo from '../../static/footer/footer_logo.svg';
import footerSocialBg from '../../static/footer/footer_social_bg.svg';
import footerInstagram from '../../static/footer/footer_instagram.svg';
import footerFacebook from '../../static/footer/footer_facebook.svg';

const Footer = () => {
  const { sections } = useNavigation();
  
  // Get only active sections
  const activeQuickLinks = sections.filter(section => section.isActive);
  
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-main-content">
            {/* Left Content */}
            <div className="footer-left">
              {/* Logo and decorative elements */}
              <div className="footer-logo">
                <img src={footerLogo} alt="Logo" />
              </div>
              
              {/* Title */}
              <div className="footer-title">
                <span className="footer-title-child">Child</span>
                <span className="footer-title-story">Story Time</span>
              </div>
              
              {/* Description */}
              <div className="footer-description">
                Have questions, feedback, or just want to say hello? We'd love to hear from you! Our team is here to help and make your experience magical.
              </div>
            </div>
            
            {/* Center Links Container */}
            <div className="footer-links-container">
              {/* Quick Links */}
              <div className="footer-quick-links">
                <div className="footer-section-title">Quick Links:</div>
                <div className="footer-links-list">
                  {activeQuickLinks.map(link => (
                    <Link 
                      key={link.id} 
                      to={link.path} 
                      className="footer-link"
                    >
                      {link.label}
                    </Link>
                  ))}
                </div>
              </div>
              
              {/* Legal */}
              <div className="footer-legal">
                <div className="footer-section-title">Legal:</div>
                <div className="footer-links-list">
                  <Link to="/privacy" className="footer-link">Privacy Policy</Link>
                  <Link to="/terms" className="footer-link">Terms of Service</Link>
                </div>
              </div>
              
              {/* Social */}
              <div className="footer-social">
                <div className="footer-section-title">Social:</div>
                <div className="footer-social-icons">
                  {/* Instagram */}
                  <div className="social-icon-container">
                    <img src={footerSocialBg} alt="" className="social-icon-bg" />
                    <img src={footerInstagram} alt="Instagram" className="social-icon" />
                  </div>
                  
                  {/* Facebook */}
                  <div className="social-icon-container">
                    <img src={footerSocialBg} alt="" className="social-icon-bg" />
                    <img src={footerFacebook} alt="Facebook" className="social-icon" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Bottom Divider */}
          <div className="footer-divider"></div>
          
          {/* Copyright */}
          <div className="footer-copyright">
            © {new Date().getFullYear()} Child Story Time. All Rights Reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;